import React from 'react';
import { Box, Button, Typography } from '@mui/material';

export default function ChatArtifactFindLeadsButton({
  action = null,
  running = false,
  onRunAction,
}) {
  if (!action) return null;

  const disabled = action.enabled === false || running;
  const label = running
    ? 'Finding leads…'
    : `${action.label}${action.cost_label ? ` (${action.cost_label})` : ''}`;

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Button
        size="small"
        variant="outlined"
        disabled={disabled}
        onClick={() => onRunAction?.(action.key)}
        sx={{ borderRadius: '8px', textTransform: 'none' }}
      >
        {label}
      </Button>
      {action.enabled === false && action.disabled_reason && (
        <Typography variant="caption" color="text.secondary">
          {action.disabled_reason}
        </Typography>
      )}
    </Box>
  );
}
